import { render } from "./InputLabel.vue?vue&type=template&id=52fcf534&scoped=true"
import script from "./InputLabel.vue?vue&type=script&lang=js"
export * from "./InputLabel.vue?vue&type=script&lang=js"

import "./InputLabel.vue?vue&type=style&index=0&id=52fcf534&lang=scss&scoped=true"

import exportComponent from "/var/www/gift/data/www/giftxyz.com/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-52fcf534"]])

export default __exports__